import { CurrencyRupeeOutlined, InfoOutlined, MonetizationOnOutlined } from '@mui/icons-material'
import { calculateTotalCost } from 'lib/utilities/calculateCost'
import { UserAuth } from 'provider/AuthProvider'
import React from 'react'
import { Link } from 'react-router-dom'
import { Tutorial } from "provider/TutorialProvider";
const TotalCostCard = ({ formData, customSkills, pricingRoute = null }) => {
  const { candidates, experience } = formData;
  const { wallet, experiencePrice, coinPrice, skillPrice } = UserAuth();
  const customSkillsCount = customSkills || 0;

  const costBase = candidates.length > 0 && experience ?
    calculateTotalCost(1, experience, experiencePrice, coinPrice, skillPrice, customSkillsCount) : null;

  const costDetails = candidates.length > 0 && experience
    ? calculateTotalCost(candidates.length, experience, experiencePrice, coinPrice, skillPrice, customSkillsCount)
    : null;

  const hasInsufficientCoins = costDetails && wallet?.Coins < costDetails.totalCoins;
  const { tutorialSteps} = Tutorial();
  return (
    <div className="p-5 border border-gray-200 rounded-lg bg-white shadow-sm transition-all duration-300" data-step={tutorialSteps.COST_CARD}>
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-semibold text-gray-800">Cost Summary</h3>
            {hasInsufficientCoins && (
              <div className="flex items-center text-sm text-red-600 font-medium">
                <InfoOutlined className="w-4 h-4 mr-1" />
                Insufficient coins
              </div>
            )}
          </div>
          <p className="text-sm text-gray-500">
            Total Candidates: {candidates.length} | Base Cost: {costBase.baseCoins} coins (₹{costBase.baseAmount})/candidate
            {customSkillsCount > 0 && ` + ${costBase.customSkillsCoins} coins (₹${costBase.customSkillsAmount})/candidate for custom skills`}
          </p>
        </div>
        <div>
          {pricingRoute ?
            <a href={`${pricingRoute}`} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors"
            >
              <InfoOutlined className="w-4 h-4" />
              View Payment Terms
            </a>
            :
            <Link
              to={"/admin/pricing"}
              target="_blank"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors"
            >
              <InfoOutlined className="w-4 h-4" />
              View Payment Terms
            </Link>
          }
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="group p-3 rounded-lg hover:bg-blue-50/50 transition-all duration-300">
          <div className="flex items-center space-x-3">
            <div className="p-2.5 bg-blue-50 rounded-full border border-blue-200 group-hover:bg-blue-100 transition-colors">
              <MonetizationOnOutlined className="text-blue-600" style={{ width: "24px", height: "24px" }} />
            </div>
            <div>
              <p className="text-xs text-gray-500 group-hover:text-gray-700">Total Coins (₹{coinPrice}/coin)</p>
              <p className="text-xl font-bold text-blue-600">{costDetails?.totalCoins}</p>
            </div>
          </div>
        </div>
        <div className="group p-3 rounded-lg hover:bg-emerald-50/50 transition-all duration-300">
          <div className="flex items-center space-x-3">
            <div className="p-2.5 bg-emerald-50 rounded-full border border-emerald-200 group-hover:bg-emerald-100 transition-colors">
              <CurrencyRupeeOutlined className="text-emerald-600" style={{ width: "24px", height: "24px" }} />
            </div>
            <div>
              <p className="text-xs text-gray-500 group-hover:text-gray-700">Total Worth</p>
              <p className="text-xl font-bold text-emerald-600">₹{costDetails?.totalAmount}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TotalCostCard;